module.exports = __webpack_public_path__ + "img/icon_step_content02.6c7cf93b.png";